import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Activity from '../Activity/Activity';
import Profile from '../Profile/Profile';
import './Home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'



const Home = () => {

    //load activities and set to activities by fetch
    const [activities, setActivities] = useState([]);
    useEffect(() => {
        fetch('activities.json')
            .then(res => res.json())
            .then(data => setActivities(data))
    }, []);

    //Handle add to time 
    const [time, setTime] = useState(0);
    const addTime = (selectedTime) => {
        const newTime = parseInt(time) + parseInt(selectedTime);
        setTime(newTime);
    }

    return (
        <div className='all-container'>
            <div className='mt-10'>
                <h1 className='text-4xl font-bold text-teal-500 text-center my-6'>  <FontAwesomeIcon icon={faCalendarDays} /> My Daily Activities</h1>
                <div className='activities-container grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-3 gap-3'>
                    {
                        activities.map(activity => <Activity
                            activity={activity}
                            addTime={addTime}
                            key={activity.id}
                        ></Activity>)
                    }

                </div>
            </div>
            <div className='profile-container'>
                <Profile time={time}></Profile>
            </div>
        </div>
    );
};

export default Home;